export default __webpack_public_path__ + "static/media/share.d4f8af97.svg";